import styled from 'styled-components'

export const WrapperColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`

export const WrapperRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
`

export const ColorCodeWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: fit-content;
    height: fit-content;
`

export const ColorCodeBox = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'bgColor',
})<{ bgColor: string }>`
    height: 3rem;
    width: 3rem;
    background-color: ${(props) => props.bgColor};
    margin-right: 1rem;

    @media (max-width: 768px) {
        height: 2rem;
        width: 2rem;
    }
`

export const ColorCodeText = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;

    @media (max-width: 768px) {
        font-size: 12px;
    }
`

export const Title = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 500;
    margin: 0;
    margin-top: 2rem;
    margin-left: 1rem;
    margin-bottom: 1.5rem;
`

export const SmallTitle = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 500;
    margin: 0;
    margin-top: 2rem;
`

export const SummaryContainer = styled.div`
    display: flex;
    width: max-content;
    margin-top: 0.25rem;
    padding: 1rem;
    border: 1px solid #ccc;

    @media (max-width: 768px) {
        width: 100%;
        flex-direction: column;
        padding: 0.5rem;
        box-sizing: border-box;
    }
`

export const SummaryRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 0.5rem 0;
`

export const SummaryColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-width: 40vh;

    @media (max-width: 768px) {
        min-width: auto;
        width: 100%;
    }
`

export const SummaryText = styled.p`
    margin: 0;

    @media (max-width: 768px) {
        font-size: 0.9rem;
    }
`

export const TicketPrice = styled.p`
    font-weight: bold;
    font-size: 1rem;
    margin-left: 1rem;
    width: auto;
    white-space: nowrap;

    @media (max-width: 768px) {
        margin-left: 0;
        font-size: 0.9rem;
    }
`

export const Checkbox = styled.div`
    margin-top: 1rem;
    display: flex;
    align-items: center;

    label {
        font-family: 'Poppins', sans-serif;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;

        input {
            margin-right: 0.5rem;
            accent-color: #ba9d31;
        }
    }
`
